import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Component for protecting routes from unauthenticated users
const ProtectedRoute = ({ allowedRoles = [] }) => {
  const { currentUser, loading } = useAuth();
  
  // Show loading indicator while authentication state is being determined
  if (loading) {
    return <div className="loading">Loading...</div>;
  }
  
  // Redirect to login if not authenticated
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }
  
  // If roles are specified, check if user has required role
  if (allowedRoles.length > 0 && !allowedRoles.includes(currentUser.role)) {
    // Redirect to dashboard if authenticated but unauthorized
    return <Navigate to="/dashboard" replace />;
  }
  
  // Render child routes if authenticated and authorized
  return <Outlet />;
};

export default ProtectedRoute;
